import { render, staticRenderFns } from "./driverInfo.vue?vue&type=template&id=7f135671&"
import script from "./driverInfo.vue?vue&type=script&lang=js&"
export * from "./driverInfo.vue?vue&type=script&lang=js&"
import style0 from "./driverInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports